import {Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, of, Subject} from "rxjs";
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";
import {StringUtils} from "@ispm/shared/utils/String.utils";
import {get, map} from 'lodash';
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'ispm-clinical-dashboard',
  templateUrl: './clinical-dashboard.component.html',
  styleUrls: ['./clinical-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('ClinicalDashboard')
export class ClinicalDashboardComponent implements OnInit {

  private destroyed$: Subject<any> = new Subject();
  public type: string = 'tab';
  widgetUpdateValueCallback: (value) => void;
  public isTrendsActive: boolean = false;
  @Input() isScrollable: boolean = false;
  @Input() set config(_config: any) {
    let applicationId = get(_config, 'application');
    let userActionCreatorServiceUnsc = this.userActionCreatorService.getStore().select("organizationConfiguration")
      .takeUntil(this.destroyed$.asObservable())
      .subscribe(data => {
      let applications = get(data, 'applications');
      if (applications && Array.isArray(applications)) {
        let currentApplication = applications.find( app => get(app, 'appId') === applicationId);
        if (currentApplication) {
          let profiles = get(currentApplication, 'profiles');
          if (profiles && Array.isArray(profiles)) {
            let profileIds = map(profiles, 'reference');
            if (profileIds) {
              this._http.get(`/appConfiguration?_id=${profileIds.join(',')}&context=ClinicalDashboard&_fieldslist=config,name,text`)
                .takeUntil(this.destroyed$.asObservable())
                .map(data => {
                  return data.json();
                }).subscribe(profileConfigs => {
                if (profileConfigs && Array.isArray(profileConfigs) && profileConfigs.length > 0) {
                  this.tabsTitles = [];
                  for(let prof of profiles) {
                    let currentAppProfile = profileConfigs.find(profile => get(profile, 'id') == get(prof, 'reference'));
                    if(currentAppProfile) {
                      this.tabsTitles.push({
                        'name': get(currentAppProfile, 'text'),
                        'type': get(currentAppProfile, 'config.layoutType'),
                        'trendsType': get(currentAppProfile, 'config.trends.layoutType'),
                        'isScrollable': get(currentAppProfile, 'config.isScrollable')
                      })
                    }
                  }
                  this.tabsTitles$.next(this.tabsTitles);
                  if (this.tabsTitles && this.tabsTitles.length > 0) {
                    const selectedClinicalDashboard = sessionStorage.getItem("selectedClinicalDashboard");
                    if (selectedClinicalDashboard) {
                      this.onTabChanged(this.tabsTitles.find(item => get(item, 'name') === selectedClinicalDashboard));
                    } else {
                      this.onTabChanged(this.tabsTitles[0]);
                    }
                  }
                }
              });
            }
          }
        }
      }
    });

  };
  patientId;
  @Input() layoutParams: Observable<any>;
  selectedTabName: string;
  selectedTab: any;
  private tabsTitles = [];

  public tabsTitles$ = new BehaviorSubject([]);

  /**
   * set card dashboard widget config
   * @param _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {

  }

  /**
   * set card dashboard widget data
   * @param widgetData
   */
  set widgetData(widgetData: any) {

  }

  constructor(private userActionCreatorService: UserActionCreatorService,
              private _http: HttpInterceptorService,
              private routerManagerService: RouterManagerService,
              private _userActionCreatorService: UserActionCreatorService,
              private _changeDetector: ChangeDetectorRef,
              private activatedRoute: ActivatedRoute) {
    this.activatedRoute.data
      .pipe(takeUntil(this.destroyed$.asObservable()))
      .subscribe(data => {
      this.config = data.resolveFn;
    });
  }

  ngOnInit() {
    this.type = this.routerManagerService.parameters.type || 'tab';
    // this._userActionCreatorService.getCurrentUser().pipe(takeUntil(this.destroyed$.asObservable()))
    //   .subscribe(user => {
    //     if(isEmpty(user)) {
    //       sessionStorage.removeItem('selectedClinicalDashboard');
    //       if (this.tabsTitles && Array.isArray(this.tabsTitles)) {
    //         this.tabsTitles.forEach(item => {
    //           let tabName = get(item, 'name', '').replace(" ", "").toLowerCase();
    //           sessionStorage.removeItem('filter' + tabName);
    //           sessionStorage.removeItem('trendsSelectedItems' + tabName);
    //         });
    //       }
    //     }
    //   });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.isTrendsActive = false;
  }

  onTabChanged(tabs) {
    this.selectedTabName = get(tabs, 'name');
    this.selectedTab = tabs;
    this.isScrollable = get(tabs, 'isScrollable', false);
    this.layoutParams = of({type: get(tabs, 'type'), isScrollable: this.isScrollable});
    this.isTrendsActive = false;
    sessionStorage.setItem("selectedClinicalDashboard", this.selectedTabName);
  }

  cssClassFormat(className: string) {
    return StringUtils.cssClassFormat(className);
  }

  toggleDashboardAndTrends(status) {
    if (status != this.isTrendsActive) {
      this.isTrendsActive = status;
      let type = this.isTrendsActive ? get(this.selectedTab, 'trendsType') : get(this.selectedTab, 'type');
      this.layoutParams = of({type: type, isScrollable: this.isScrollable});
    }
  }

}
